<div class="modal fade" aria-hidden="true">
    <div class="modal-dialog modal-dialog-scrollable">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title">
                    Importar Regiões do ERP
                </h4>        
            </div>
            <div class="modal-body">
                <form #form="ngForm" novalidate>
                    <ng-template [ngIf]="filter">
                        <div class="row">
                            <div class="form-group col-12">
                                <label for="importModalIntegracao" class="col-form-label">ERP</label>
                                <select class="form-control" name="importModalIntegracao" id="importModalIntegracao" 
                                    [ngModel]="filter.idIntegracao || ''" (ngModelChange)="filter.idIntegracao = $event ? $event : null"
                                    #importModalIntegracao="ngModel" required="required">
                                    <option *ngFor="let integracao of integracoes" [ngValue]="integracao.id">{{integracao.nome}}</option>
                                </select>  
                                <p class="form-text text-muted">ERP que será importado as regiões</p>
                                <sgt-form-control-error
                                    *ngIf="importModalIntegracao.errors && importModalIntegracao.errors.required && importModalIntegracao.dirty"
                                    msgError="É obrigatório selecionar o ERP que deseja importar os pedidos">
                                </sgt-form-control-error>                                       
                            </div>                        
                        </div> 

                        <div class="row">
                            <div class="form-group col-12">
                                <label for="importModalCodigoIntegracao" class="col-form-label">Código ERP</label>
                                <input type="text" class="form-control" [(ngModel)]="filter.codigoIntegracao" name="importModalCodigoIntegracao" id="importModalCodigoIntegracao"
                                    #importModalcodigoIntegracao="ngModel">
                                <p class="form-text text-muted">Código da região no ERP</p>
                            </div>
                        </div>
                        <div class="row">
                            <div class="form-group col-12">
                                <label for="importModalNome" class="col-form-label">Nome</label>
                                <input type="text" class="form-control" [(ngModel)]="filter.nome" name="importModalNome" id="importModalNome"
                                    #importModalNome="ngModel">
                            </div>
                        </div>                                                                        
                        <div class="row">
                            <div class="form-group col-12 col-md">
                                <label class="col-form-label" for="importModalDataCadastroInicial">Data Cadastro Inicial</label>
                                <sgt-datepicker [(ngModel)]="filter.dataCadastroInicial" name="importModalDataCadastroInicial" id="importModalDataCadastroInicial"
                                    #importModalDataCadastroInicial="ngModel" #datePickerDataCadastroInicial [ngControl]="importModalDataCadastroInicial">
                                </sgt-datepicker>
                                <p class="form-text text-muted">Regiões cadastradas a partir desta data</p>
                            </div> 
                            <div class="form-group col-12 col-md">
                                <label class="col-form-label" for="importModalDataCadastroFinal">Data Cadastro Final</label>
                                <sgt-datepicker [(ngModel)]="filter.dataCadastroFinal" name="importModalDataCadastroFinal" id="importModalDataCadastroFinal"
                                    #importModalDataCadastroFinal="ngModel" #datePickerDataCadastroFinal [ngControl]="importModalDataCadastroFinal">
                                </sgt-datepicker>
                                <p class="form-text text-muted">Regiões cadastradas até esta data</p>
                            </div>                                                     
                        </div>                      
                    </ng-template>
                </form>
            </div>
            <div class="modal-footer">           
                <button type="button" class="btn btn-light" (click)="close()">
                    Cancelar
                </button>
                <button type="button" class="btn btn-primary" (click)="import()" [disabled]="form.invalid">
                    <i class="fas fa-download"></i> Importar
                </button>                  
            </div>            
        </div>
    </div>
</div>